import PropTypes from 'prop-types'
import React from 'react'

import SuggestionsListItem from './suggestionsListItem'

const SuggestionsList = props => {
  const {
    suggestions,
    styles,
    focusedIndex,
    inputValue,
    textInputRef,
    wrapperRef,
    setMenuRef,
    onMenuClick,
    handleMenuMouseEnter,
    handleMenuMouseLeave
  } = props
  /**
   * Hack inline style :magic:
   */
  const wrapperStyle = {
    position: 'absolute',
    top: textInputRef.clientHeight,
    width: wrapperRef.clientWidth
  }

  return (
    <div className={styles.wrapper} style={wrapperStyle}>
      <section ref={setMenuRef} className={styles.suggestions}>
        <ul className="fds-c-text-list -style-none">
          {suggestions.map((suggestion, index) => {
            let showSeparator = false
            if (
              index > 0 &&
              suggestions[index - 1].type !== suggestions[index].type
            ) {
              showSeparator = true
            }

            return (
              <SuggestionsListItem
                styles={styles}
                focusedIndex={focusedIndex}
                inputValue={inputValue}
                onMenuClick={onMenuClick}
                handleMenuMouseLeave={handleMenuMouseLeave}
                handleMenuMouseEnter={handleMenuMouseEnter}
                key={index}
                suggestion={suggestion}
                index={index}
                showSeparator={showSeparator}
              />
            )
          })}
        </ul>
      </section>
    </div>
  )
}

SuggestionsList.propTypes = {
  suggestions: PropTypes.array,
  styles: PropTypes.object,
  focusedIndex: PropTypes.number,
  inputValue: PropTypes.string,
  textInputRef: PropTypes.object,
  wrapperRef: PropTypes.object,
  setMenuRef: PropTypes.func,
  onMenuClick: PropTypes.func,
  handleMenuMouseEnter: PropTypes.func,
  handleMenuMouseLeave: PropTypes.func,
  showCategories: PropTypes.bool
}

export default SuggestionsList



// WEBPACK FOOTER //
// ./client/components/autosuggest/suggestionsList.js